import { RefObject } from "react";
import BaseObject from "../../models/BaseObject";
import { KnxChapterHeaderData } from "./interfaces";
import type Device from "../../models/Device";

// export interface KnxChapterItem {
//   ref?: RefObject<HTMLDivElement>;
//   parentKnxChapter?: KnxChapterItem;
//   chapterId: string;
//   instanceId: string;
//   icon?: string;
//   headerData?: KnxChapterHeaderData;
//   detailHeader?: string;
//   // header?: JSX.Element | null;
//   subChapters: Array<KnxChapterItem>;
//   content?: Array<JSX.Element> | null;
//   propertyList: Array<any>;
//   comObjectList: Array<any>;
// }

export class KnxChapterItem extends BaseObject {
  get className(): string {
    return "KnxChapterItem"; // no itx
  }
  device: Device | undefined;
  ref?: RefObject<HTMLDivElement>;
  parentKnxChapter?: KnxChapterItem;
  chapterId = "";
  instanceId = "";
  icon?: string;
  access?: string;
  headerData?: KnxChapterHeaderData;
  detailHeader?: string;
  // header?: JSX.Element | null;
  subChapters = new Array<KnxChapterItem>();
  content?: Array<JSX.Element> | null;
  propertyList = new Array<any>();
  comObjectList = new Array<any>();

  // for old display oder logic (ABB)
  displayOrder?: number;
  indent?: number;

  public get expanded() {
    return this.device?.expandedChapterIds.has(this.chapterId) ?? false;
  }
  public set expanded(value) {
    if (this.expanded != value) {
      if (value) {
        this.device?.expandedChapterIds.add(this.chapterId);
      } else {
        this.device?.expandedChapterIds.delete(this.chapterId);
      }
      this.raiseOnChange("expanded");
    }
  }
  constructor(init?: Partial<KnxChapterItem>) {
    super();
    Object.assign(this, init);
  }
}
